import { observer } from "mobx-react";
import "./index.css";
import Formula from "./view/InlineFormula";
import FormulaInput from "./view/FormulaInput";
import FormulaForm from "./view/FormulaForm";
import Table from "./view/Table";
import { provideReactivepad, withReactivepad } from "./view/ReactivepadContext";
import { Store, FormulaModel, TableModel } from "./core/Store";
import { formatters, errors } from "./core/common";
import { getFormattedValue } from "./core/utils";
import { SUPPORTED_FUNCTIONS, MOST_COMMON_FUNCTIONS } from "./core/functions";
export var components = {
  Formula: Formula,
  Table: Table,
  FormulaInput: FormulaInput,
  FormulaForm: FormulaForm
};
export { provideReactivepad, withReactivepad, getFormattedValue, formatters, errors, Store, FormulaModel, TableModel, observer, SUPPORTED_FUNCTIONS, MOST_COMMON_FUNCTIONS };
export var createStore = function createStore(snapshot) {
  var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Store.create(snapshot, env);
};